export enum Brand {
  SHERPATH_AI = 'SHERPATH_AI',
  NORA = 'NORA',
  OSMOSIS_AI = 'OSMOSIS_AI',
  AI_COACH = 'AI_COACH',
}

export const BrandNameMap: Record<Brand, string> = {
  [Brand.SHERPATH_AI]: 'Sherpath AI',
  [Brand.NORA]: 'Nora',
  [Brand.OSMOSIS_AI]: 'Osmosis AI',
  [Brand.AI_COACH]: 'AI Coach',
}
